import { accEvents, getInitialState, reflectSpan, startQuery, endHistory } from './reducer-utils'
import { ImageLogEvent, ImageLogState } from '../../types/image-log'

export const imageLogReducer: WidgetReducerType<ImageLogState, FlowMessage<LiveEvent<ImageLogEvent>>> = (
    state = getInitialState(),
    action
) => {
    switch (action?.type) {
        case 'start':
            return startQuery(action, state)
        case 'span':
            return reflectSpan(action, state)
        case 'event':
            return accEvents(action, state)
        case 'endHistory':
            return endHistory(action, state)
        default:
            return state
    }
}
